import FallbackLoader from '../FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ErrorFeedback" */'@modals/partials/cerca-casa/ErrorFeedback'));
